import { Fragment, useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/sv';
import 'dayjs/locale/en';
import calendar from 'dayjs/plugin/calendar';
import { Row, Container } from 'react-bootstrap';
import { Flex, Box } from 'theme-ui';
import DeliveryWindowRescheduler from './DeliveryWindowRescheduler';
import DeliveryTypeChanger from './DeliveryTypeChanger';
import { DeliveryStatusType } from '../../contexts/contextTypes';

const PendingContainer = ({ isCustomerService }: { isCustomerService: boolean }) => {
  const { packageId } = useParams();
  const { t, i18n } = useTranslation();
  const { trackingDetails } = useContext(AppContext);

  dayjs.extend(calendar);
  dayjs.locale(i18n.language);

  const shouldShowRescheduleButton = () => {
    // Check basic conditions first
    if (isCustomerService) return false;
    if (!trackingDetails?.task?.completeAfter) return false;
    if (!trackingDetails?.task?.completeBefore) return false;
    if (trackingDetails?.task?.status !== DeliveryStatusType.PENDING) return false;

    const currentTime = dayjs();
    const bookingDate = dayjs(trackingDetails?.task.completeBefore);

    // Create cutoff datetime by combining booking date with 14:30
    const cutoffDateTime = bookingDate.hour(14).minute(30).second(0).millisecond(0);

    // Return true if current time is before the cutoff, false otherwise
    return currentTime.isBefore(cutoffDateTime);
  };

  const canRescheduleDelivery = shouldShowRescheduleButton() && trackingDetails?.deliveryWindows && trackingDetails.deliveryWindows.length > 0;

  const canChangeDeliveryType = false; // shouldShowRescheduleButton() && trackingDetails?.enableDeliveryTypeChange && trackingDetails?.task?.status === DeliveryStatusType.PENDING;

  return (
    <Fragment>
      {trackingDetails?.announcement && (
        <Flex sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '10px' }}>
          <Box className="announcement-box">
            <span>⚠️</span>
            <span className="blink-text">{trackingDetails?.announcement}</span>
          </Box>
        </Flex>
      )}
      <Container>
        <Row className="home_container">
          <div className="summary_container">
            <div className="summary_container--header">
              <p style={{ marginBottom: 10 }}>{t('tracking_number')}</p>
              <h3 style={{ marginBottom: 40 }}>{trackingDetails?.package?.externalPackageId}</h3>
            </div>

            <p style={{ marginBottom: 10 }}>{t('delivery_time')}</p>
            {trackingDetails?.eta?.lowerBound && trackingDetails?.eta?.upperBound ? (
              <DeliveryWindowRescheduler
                packageId={packageId!}
                taskId={trackingDetails.task!.id}
                eta={trackingDetails.eta}
                deliveryWindows={trackingDetails.deliveryWindows || []}
                canReschedule={!!canRescheduleDelivery}
              />
            ) : (
              <h3
                style={{
                  marginBottom: 20,
                  fontSize: '18px'
                }}
              >
                {t('eta.eta_error')}
              </h3>
            )}

            {trackingDetails?.task?.id && trackingDetails?.task?.taskType && (
              <DeliveryTypeChanger
                canChangeDeliveryType={!!canChangeDeliveryType}
                taskId={trackingDetails.task.id}
                taskType={trackingDetails.task.taskType}
                pickupPoints={trackingDetails.pickupPoints || []}
                currentPickupPointId={trackingDetails.packageLocker?.externalLockerId || undefined}
              />
            )}

            {canRescheduleDelivery || !!canChangeDeliveryType ? <p>{t('reschedule_message')}</p> : <p>{t('delivery_summary')}</p>}
          </div>
        </Row>
      </Container>
    </Fragment>
  );
};

export default PendingContainer;
